// src/components/Graph.tsx
import React, { useEffect, useState } from 'react';
import ReactFlow, { Node, Edge, Background, Controls, Position, OnConnect, Connection } from 'react-flow-renderer';
import dagre from 'dagre';

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

const getLayoutedElements = (nodes: Node[], edges: Edge[]) => {
  const nodeWidth = 172;
  const nodeHeight = 36;
  const isHorizontal = false;

  dagreGraph.setGraph({ rankdir: isHorizontal ? 'LR' : 'TB' });

  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
  });

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  nodes.forEach((node) => {
    const nodeWithPosition = dagreGraph.node(node.id);
    node.targetPosition = isHorizontal ? Position.Left : Position.Top;
    node.sourcePosition = isHorizontal ? Position.Right : Position.Bottom;

    // We are shifting the dagre node position (anchor=center) to the top-left for react-flow compatibility
    node.position = {
      x: nodeWithPosition.x - nodeWidth / 2,
      y: nodeWithPosition.y - nodeHeight / 2,
    };

    return node;
  });

  return { nodes, edges };
};

const GraphEditor: React.FC<{graphNodes : Node[], graphEdges : Edge[]}> = ({graphNodes, graphEdges}) => {
  const [elements, setElements] = useState<{ nodes: Node[]; edges: Edge[] }>({ nodes: [], edges: [] });

  console.log({graphNodes})
  console.log({graphEdges})
  

  useEffect(() => {
    const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(graphNodes, graphEdges);
    setElements({ nodes: layoutedNodes, edges: layoutedEdges });
  }, []);

  const onNodeClick = (event: React.MouseEvent, node: Node) => {
    console.log('Node clicked:', node.id);
    if (window.top) {
      window.top.location = `https://cycle-tracker-backend.admin.datocms.com/editor/item_types/QUaUsTmhTxeZBlH2rGvxYg/items/${node.id}`;
    }
  };

  const onEdgeClick = (event: React.MouseEvent, edge: Edge) => {
    console.log('Edge clicked:', edge.id);
  };

  const onConnect: OnConnect = (params: Connection) => {
    /*const {source, target} = params;
    console.log(source, target)
    setElements((elements) => {
      const answer = prompt("What should be the new answer?")
      console.log("Set elements callback executed")
      elements.edges.push({ id: `${source}_${target}`, source: source ?? "", target: target ?? "", animated: true, label: a })
      const { nodes, edges } = getLayoutedElements(elements.nodes, elements.edges);
      return {edges:[...edges], nodes:[...nodes]};
    });*/
  };
  console.log("Rerender the whole")
  console.log(elements)
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <ReactFlow 
        nodes={elements.nodes} 
        edges={elements.edges}
        onNodeDoubleClick={onNodeClick}
        onEdgeDoubleClick={onEdgeClick}
        onConnect={onConnect}
        >
        <Background color="#aaa" gap={16} />
        <Controls />
      </ReactFlow>
    </div>
  );
};

export default GraphEditor;
